import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseService } from 'src/app/shared/services/base.service';
import { CheckActiveSessionResponseDto } from 'src/app/shared/dto/check-active-session-response.dto';

@Injectable({
  providedIn: 'root',
})
export class ShiftSessionsService extends BaseService {
  constructor(httpClient: HttpClient) {
    super(httpClient, 'shift-sessions');
  }

  async checkActiveSession(machineId: number): Promise<CheckActiveSessionResponseDto> {
    try {
      const response = await lastValueFrom(
        this.httpClient.get<CheckActiveSessionResponseDto>(`${this.url}/check-active/${machineId}`)
      );
      return new CheckActiveSessionResponseDto(response);
    } catch (error: any) {
      throw new Error(`Error al verificar sesión activa: ${error.message}`);
    }
  }
}
